import type { Edge } from '@xyflow/react'
import { addEdge, createEdgeId, createNode, flowStore } from './flow-store'

const DEFAULT_SOURCE_NODE_GAP_X = 160
const DEFAULT_UPSTREAM_NODE_WIDTH = 280
type GetInternalNode = (nodeId: string) => { measured?: { width?: number; height?: number } } | undefined

export type NodePos = 'up' | 'down';//上下游区分

interface CreateLinkedNodeFromSourceOptions {
    sourceNodeId: string
    targetNodeId?: string
    type: string
    customData: any
    offset?: {
        x?: number
        y?: number
    },
    pos: NodePos
    connect?: boolean
    edgeData?: Edge['data']
    sourceHandle?: string
    targetHandle?: string
    getInternalNode?: GetInternalNode
    sourceNodeWidth?: number
    targetNodeWidth?: number
}

interface CreateLinkedNodeFromSourceResult {
    nodeId: string
    edgeId?: string
}

export function getSourceNodeMeasuredSize(sourceNodeId: string, getInternalNode?: GetInternalNode) {
    const measured = getInternalNode?.(sourceNodeId)?.measured
    return {
        width: measured?.width ?? 0,
        height: measured?.height ?? 0,
    }
}

export function createLinkedNodeFromSource({
    sourceNodeId,
    targetNodeId,
    type,
    customData,
    offset,
    connect = true,
    edgeData,
    pos,
    sourceHandle,
    targetHandle,
    getInternalNode,
    sourceNodeWidth,
    targetNodeWidth,
}: CreateLinkedNodeFromSourceOptions): CreateLinkedNodeFromSourceResult {
    const currentNode = flowStore.nodes[sourceNodeId]
    const currentSourceWidth = sourceNodeWidth ?? getSourceNodeMeasuredSize(sourceNodeId, getInternalNode).width
    const currentTargetWidth = targetNodeWidth ?? DEFAULT_UPSTREAM_NODE_WIDTH
    const linkedNodeOffsetWidth = pos == 'down'
        ? currentSourceWidth
        : currentTargetWidth
    const flag = pos == 'down' ? 1 : -1;
    const position = {
        x: (currentNode?.position.x ?? 0) + linkedNodeOffsetWidth * flag + (offset?.x ?? DEFAULT_SOURCE_NODE_GAP_X * flag),
        y: (currentNode?.position.y ?? 0) + (offset?.y ?? 0),
    }

    const { id: nodeId } = createNode({
        type, nodeId: targetNodeId,
        position, customData,
        parentId: currentNode?.parentId
    })

    if (!connect) {
        return { nodeId }
    }

    const source = pos == 'down' ? sourceNodeId : nodeId
    const target = pos == 'down' ? nodeId : sourceNodeId
    const edgeId = createEdgeId({ source, target })
    addEdge({
        id: edgeId,
        source,
        target,
        ...(edgeData ? { data: edgeData } : {}),
        ...(sourceHandle ? { sourceHandle } : {}),
        ...(targetHandle ? { targetHandle } : {}),
    })

    return {
        nodeId,
        edgeId,
    }
}
